<template>
  <div class="browser-warning-panel">
    <div class="browser-warning-panel-component">
      <div class="component-background" @click="close" />
      <div class="wrapper" @click="openChrome">
        <!-- <button class="delete is-medium close" @click="close" /> -->
        <div class="columns is-mobile">
          <p class="column is-narrow">
            <img src="/img/home2/chrome.svg" @click="openChrome" />
          </p>
          <p class="column warning">
            {{ $t("bad-browser") }}
            <i class="fa fa-chevron-right" style="margin-left: 4px" />
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BrowserWarningPanel",
  components: {},
  data() {
    return {};
  },
  mounted() {
    setTimeout(() => this.close(), 15 * 1000); // July 2022: only shows for workers now
  },
  methods: {
    close() {
      this.$emit("close");
    },
    openChrome() {
      var url = window.location.href.replace("https://", "");
      var newURL = `intent://${url}#Intent;scheme=https;package=com.android.chrome;end`;
      window.location.href = newURL; // window.open(url, "_target");
    },
  },
};
</script>

<style scoped>
.component-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.25);
  z-index: 2;
}
.wrapper {
  position: absolute;
  top: 0px;
  width: 100vw;
  backdrop-filter: blur(8px);
  background-color: rgba(149, 255, 181, 0.7);
  padding: 12px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.35);
  z-index: 21;
  border-bottom-right-radius: 25px;
  border-bottom-left-radius: 25px;
}
img {
  height: 50px;
  width: 50px;
  filter: drop-shadow(0 0 2px grey);
}
.close {
  position: absolute;
  right: 0;
  top: 0;
  margin: 10px;
}
.warning {
  text-align: left;
  font-size: 1.1em;
  font-weight: 500;
  padding-left: 0;
}
</style>